export default __webpack_public_path__ + "static/media/logout.0db4d6d2.svg";